
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindShaft4 as ObiWindShaft4Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-shaft-4.js';
 
 
 

 
 export const ObiWindShaft4 = createComponent({
   react: React,
   tagName: 'obi-wind-shaft-4',
   elementClass: ObiWindShaft4Element,
   events: {
     
   }
  });
 
 